import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { Icon } from '@/components/ui/icon.component';
import { cn } from '@/utils/cn-tw-merge';

interface ArrowButtonProps {
  icon: IconDefinition;
  disabled: boolean;
  onClick: () => void;
  ariaLabel: string;
  testId: string;
  borderClassName: string;
}

function ArrowButton({ icon, disabled, onClick, ariaLabel, testId, borderClassName }: ArrowButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
      className={cn(
        'flex items-center justify-center size-6 rounded-full border transition-colors mt-3 mx-1',
        'disabled:cursor-not-allowed disabled:opacity-40',
        borderClassName,
      )}
      onClick={onClick}
    >
      <Icon icon={icon} size="lg" className="text-gray-700" />
    </button>
  );
}

interface SlotsArrowProps {
  disabled: boolean;
  onClick: () => void;
  testId: string;
}

export function SlotsPrevArrow({ disabled, onClick, testId }: SlotsArrowProps) {
  return (
    <ArrowButton
      icon={faAngleLeft}
      disabled={disabled}
      ariaLabel="Datas anteriores"
      testId={testId}
      borderClassName="border-gray-400"
      onClick={onClick}
    />
  );
}

export function SlotsNextArrow({ disabled, onClick, testId }: SlotsArrowProps) {
  return (
    <ArrowButton
      icon={faAngleRight}
      disabled={disabled}
      ariaLabel="Próximas datas"
      testId={testId}
      borderClassName="border-gray-500"
      onClick={onClick}
    />
  );
}
